import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";

import { useLanguage } from "context/LanguageContext";
import ProfileSettings from "views/admin/settings";

const UserProfileReadonly = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const { userId } = useParams<{ userId: string }>();

  const handleBack = React.useCallback(() => {
    const fromState = (location.state as { from?: string } | null)?.from;
    if (fromState) {
      navigate(fromState);
      return;
    }

    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    if (location.pathname.startsWith("/systemadmin")) {
      navigate("/systemadmin/users-management");
      return;
    }

    navigate("/admin/users");
  }, [location.pathname, location.state, navigate]);

  if (!userId) {
    return (
      <div className="mt-5 rounded-lg bg-red-50 p-4 text-sm text-red-600 dark:bg-red-500/10 dark:text-red-300">
        {t("usersMgmt.userNotFound")}
      </div>
    );
  }

  return (
    <div className="mt-5 flex flex-col gap-4">
      <div>
        <button
          type="button"
          onClick={handleBack}
          className="inline-flex items-center gap-1.5 rounded-lg border border-line px-3 py-1.5 text-sm font-medium text-ink hover:bg-surface-hover"
        >
          <MdArrowBack className="h-4 w-4" />
          {t("action.back")}
        </button>
      </div>

      <ProfileSettings readonlyUserId={userId} />
    </div>
  );
};

export default UserProfileReadonly;
